var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebchatActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.4 16.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:none;stroke:#3aaf50;stroke-linejoin:round;stroke-width:1.4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 8.2,
    cy: 8.2,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1.78,4.35c1.96,.87,4.14,1.35,6.42,1.35s4.46-.48,6.42-1.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1.78,12.05c1.96-.87,4.14-1.35,6.42-1.35s4.46,.48,6.42,1.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M8.2,.7c-4,4.2-4,10.8,0,15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M8.2,.7c4,4.2,4,10.8,0,15"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebchatActive);
export default __webpack_public_path__ + "static/media/Webchat.Active.830864a76025ead8ef62273885aa237a.svg";
export { ForwardRef as ReactComponent };